import type { LeadTimeCalculatorInput } from '@calculations/lead-time/input';
import { extractWeeks } from '@calculations/lead-time/time';

import {
  RAFFixedMarket,
  RAFFixedMarketLeadTimeStrategy,
  RAFFixedMarketLeadTimeStrategyResult,
} from './types';

export function runRAFFixedMarketStrategy(
  strategy: RAFFixedMarketLeadTimeStrategy,
  input: LeadTimeCalculatorInput,
): RAFFixedMarketLeadTimeStrategyResult {
  const { default: defaultParts, nasParts } = strategy.config;

  const { partId } = input;

  let weeks = extractWeeks(defaultParts);

  if (partId.startsWith('NAS')) {
    weeks = extractWeeks(nasParts);
  }

  return {
    name: RAFFixedMarket,
    weeks,
  };
}
